import { ENV } from '../../config/runtimeEnv';

import { PatientOverview } from "../../types/healthcare/PatientOverviewTypes";
import type { UserUuid } from "../../types/identity";
import { http } from "../../lib/http/client";

const BASE = ENV.VITE_HEALTHCARE_SERVER;

/**
 * Fetches the aggregated patient overview (tests, medical history, medications,
 * appointments, treatment plans, analysis status + toolbar summary) in a single
 * round trip. Replaces the previous per-domain healthcare calls in the modal.
 */
export const fetchPatientOverview = async (
	patientId: UserUuid,
): Promise<PatientOverview> => {
	const response = await http.get(`${BASE}/practitioner/patients/${patientId}/overview`);
	return response.data;
};
